module.exports = __webpack_public_path__ + "static/media/luckey_7B.c723ad56.jpg";